/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   getMatchingEntity
 */

const getMatchingEntity = <T extends { cityStateName?: string; url?: string }>(
  entities?: readonly T[],
  url?: string
) => {
  if (Array.isArray(entities) && entities.length) {
    let closestEntity: T | undefined

    if (url) {
      entities.some((entity) => {
        if (entity?.cityStateName === url || entity?.url === url) {
          closestEntity = entity
          return true
        }
        return false
      })
    }

    return closestEntity
  }

  return undefined
}

export default getMatchingEntity
